import React, { useEffect, useState } from "react";
import LemonWireLogo from "./LemonWireLogo";

/**
 * XP-era "Professional Edition" boot splash. Self-dismisses after ~2.6s and
 * stores a flag in localStorage so subsequent loads skip it (unless explicitly replayed).
 */
export default function BootScreen({ onDone, persist = true }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 900);
    const t2 = setTimeout(() => setPhase(2), 1800);
    const t3 = setTimeout(() => {
      if (persist) {
        try { localStorage.setItem("lw_seen_boot", "1"); } catch { /* ignored */ }
      }
      onDone?.();
    }, 2800);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onDone, persist]);

  return (
    <div
      data-testid="boot-screen"
      className="fixed inset-0 bg-black z-[200] flex flex-col items-center justify-center cursor-pointer select-none"
      onClick={() => {
        if (persist) { try { localStorage.setItem("lw_seen_boot", "1"); } catch {} }
        onDone?.();
      }}
    >
      <div className="flex flex-col items-center gap-4">
        <LemonWireLogo size={80} withText />
        <div className="text-[#FFEB3B] text-[11px] tracking-[0.25em] uppercase font-bold">
          Professional · v2.7.32 Gold
        </div>
        <div className="mt-4 boot-progress"><div className="boot-progress-fill" /></div>
        <div className="text-[11px] text-white/60 mt-3 font-mono h-4">
          {phase === 0 && "Loading kernel modules..."}
          {phase === 1 && "Contacting peer swarm..."}
          {phase === 2 && "Deploying LemonShield 4.2..."}
        </div>
        <div className="text-[10px] text-white/35 mt-1">Click anywhere to skip</div>
      </div>
      <div className="absolute bottom-6 text-[10px] text-white/35 font-mono">
        &copy; 2003-2026 LemonWire Labs Inc. · No files were harmed in the making of this app.
      </div>
    </div>
  );
}
